'use client';
import { useState, Suspense } from 'react';
import { CldImage } from 'next-cloudinary';
import AnimationImage from '../animation-image/animation-image';

type PageSectionImageProps = {
    url: string;
    cloudinaryId: string;
    imagePlacement: string;
    alt?: string;
};

// rest includes the inspectorProps props for live preview
export const PageSectionImage = (props: PageSectionImageProps) => {
    const { url, cloudinaryId, imagePlacement, alt = '', ...rest } = props;
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const aspectRatio = imagePlacement === 'Left' ? 'aspect-75/94' : 'aspect-20/17';

    return (
        <Suspense fallback={<div />}>
            <div className="h-full max-w-4xl mx-auto">
                <AnimationImage isImageLoaded={isImageLoaded}>
                    <div className={`relative ${aspectRatio}`}>
                        <CldImage
                            {...rest}
                            // priority
                            className="z-0 object-cover w-full h-full"
                            // style={{ objectFit: 'cover', minHeight: 620 }}
                            src={`${cloudinaryId}`}
                            alt={alt}
                            // fill
                            width={1600}
                            height={1600}
                            sizes="(max-width: 767px) 100vw,(min-width: 768px) 40vw"
                            onLoad={() => setIsImageLoaded(true)}
                        />
                    </div>
                </AnimationImage>
            </div>
        </Suspense>
    );
};

export default PageSectionImage;
